import { render, staticRenderFns } from "./VideoSection.vue?vue&type=template&id=400e23f7&scoped=true&"
import script from "./VideoSection.vue?vue&type=script&lang=js&"
export * from "./VideoSection.vue?vue&type=script&lang=js&"
import style0 from "./VideoSection.vue?vue&type=style&index=0&id=400e23f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400e23f7",
  null
  
)

export default component.exports